import { Component, Input, OnInit } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { ProductoCuestionario } from '../../../_models/producto-cuestionario';
import { ProductoCuestionarioService } from '../../../_services/producto-cuestionario.service';
import { CuestionarioService } from '../../../_services/cuestionario.service';
import { EstadoService } from '../../../_services/estado.service';
import { Cuestionario } from '../../../_models/cuestionario';
import { Estado } from '../../../_models/estado';
import { ListaService } from '../../../_services/lista.service';
import { ListaItem } from '../../../_models/lista-item';

@Component( {
  selector: 'app-producto-cuestionario',
  templateUrl: 'producto-cuestionario.component.html'
} )

export class ProductoCuestionarioComponent implements OnInit {
  @Input() producto: Producto;
  lisCuestionarios: SelectItem[] = [];
  lisCuestionariosTodos: Cuestionario[] = [];
  lisEstados: SelectItem[] = [];
  carInformacionInicial = true;
  lisProductosCuestionarios: ProductoCuestionario[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  proCuestionarioSeleccionado: ProductoCuestionario;
  lisCausales: SelectItem[] = [];

  constructor( private proCuestionarioServicio: ProductoCuestionarioService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private estServicio: EstadoService,
               private lisServicio: ListaService,
               private cueServicio: CuestionarioService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreCuestionario', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_CUESTIONARIO' ), sort: false },
      { field: 'ponderacion', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_CONCEPTOMALO' ), sort: false },
      { field: 'nombreEstado', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_ESTADOCALIFICACION' ), sort: false },
      { field: 'causal', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_CAUSAL' ), sort: false },
      { field: 'ponderacion', header: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.LBL_CONCEPTOBUENO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.proCuestionarioServicio.listadoPorProducto( this.producto.idProducto ),
      this.cueServicio.listadoConRespuesta(), this.estServicio.listado(), this.lisServicio.getMasterDetails( 'ListasCausalesSolicitudes' ) ).subscribe( ( [ lisProductosCuestionarios, lisCuestionarios, lisEstados, lisCausales ] ) => {
      this.lisProductosCuestionarios = lisProductosCuestionarios;
      this.lisCuestionariosTodos = lisCuestionarios;

      lisCausales.map( ( s: ListaItem ) => {
        this.lisCausales.push( { label: s.nombre, value: s.idLista } );
      } );

      lisEstados.map( ( s: Estado ) => {
        if ( s.indicadorAliado ) {
          this.lisEstados.push( { label: s.nombre, value: s.idEstado } );
        }
      } );
      this.cargarCuestionarios();
      this.cargarFormulario();
      this.carInformacionInicial = false;
    } );
  }

  cargarCuestionarios() {
    this.lisCuestionarios = [];
    this.lisCuestionariosTodos.map( ( s: Cuestionario ) => {
      if ( s.indicadorHabilitado && !this.lisProductosCuestionarios.find( x => x.idCuestionario === s.idCuestionario ) ) {
        this.lisCuestionarios.push( { label: s.nombre, value: s.idCuestionario } );
      }
    } );
  }


  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoCuestionario: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.idProductoCuestionario : null ],
      idProducto: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.idProducto : this.producto.idProducto, [ Validators.required ] ],
      idEstado: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.idEstado : null, [ Validators.required ] ],
      idCausal: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.idCausal : null, [ Validators.required ] ],
      idCuestionario: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.idCuestionario : null, [ Validators.required ] ],
      ponderacion: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.ponderacion : null, [ Validators.required, Validators.maxLength( 5 ) ] ],
      indicadorHabilitado: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.indicadorHabilitado : true ],
      auditoriaUsuario: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.auditoriaUsuario : null ],
      auditoriaFecha: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.auditoriaFecha : null ],
      nombreCuestionario: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.nombreCuestionario : null ],
      nombreEstado: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.nombreEstado : null ],
      causal: [ this.proCuestionarioSeleccionado ? this.proCuestionarioSeleccionado.causal : null ]
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  guardar( proCuestionario: ProductoCuestionario, habilitado?: ProductoCuestionario ) {
    const regCrear = [];
    regCrear.push( proCuestionario );
    if ( habilitado ) {
      regCrear.push( habilitado );
    }

    const tipo = (proCuestionario.idProductoCuestionario !== '' && proCuestionario.idProductoCuestionario !== undefined && proCuestionario.idProductoCuestionario !== null) ? 2 : 1;


    this.proCuestionarioServicio.bulk( regCrear ).subscribe( cuestionarios => {
      if ( tipo === 1 ) {
        const a = cuestionarios.find( x => !habilitado || x.idProductoCuestionario != habilitado.idProductoCuestionario );
        if ( a ) {
          proCuestionario.idProductoCuestionario = a.idProductoCuestionario;
        }

        const c = this.lisCuestionarios.find( x => x.value === proCuestionario.idCuestionario );
        if ( c ) {
          proCuestionario.nombreCuestionario = c.label;
        }

        const b = this.lisEstados.find( x => x.value === proCuestionario.idEstado );
        if ( b ) {
          proCuestionario.nombreEstado = b.label;
        }

        const cs = this.lisCausales.find( x => x.value === proCuestionario.idCausal );
        if ( cs ) {
          proCuestionario.causal = cs.label;
        }

        this.lisProductosCuestionarios = [ ...this.lisProductosCuestionarios, proCuestionario ];

      } else {
        const b = this.lisEstados.find( x => x.value === proCuestionario.idEstado );
        if ( b ) {
          proCuestionario.nombreEstado = b.label;
        }

        const cs = this.lisCausales.find( x => x.value === proCuestionario.idCausal );
        if ( cs ) {
          proCuestionario.causal = cs.label;
        }


        const a = this.lisProductosCuestionarios.findIndex( x => x.idProductoCuestionario === proCuestionario.idProductoCuestionario );
        if ( a >= 0 ) {
          this.lisProductosCuestionarios[ a ] = proCuestionario;
        }
      }

      if ( habilitado ) {
        const i = this.lisProductosCuestionarios.findIndex( x => x.idProductoCuestionario === habilitado.idProductoCuestionario );
        if ( i >= 0 ) {
          this.lisProductosCuestionarios[ i ] = habilitado;
        }
      }

      this.proCuestionarioSeleccionado = null;
      this.formulario.reset();
      this.f.idProducto.setValue( this.producto.idProducto );
      this.f.indicadorHabilitado.setValue( true );
      this.cargarCuestionarios();
      this.submitted = false;
      this.guardando = false;
      this.navServicio.setMesage( tipo );
    }, error => {
      this.guardando = false;
      this.navServicio.setMesage( 3 );
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const proCuestionario = this.formulario.value;
      const habilitado = this.lisProductosCuestionarios.find( x => x.indicadorHabilitado && proCuestionario.idProductoCuestionario !== x.idProductoCuestionario );
      if ( proCuestionario.indicadorHabilitado && habilitado ) {
        this.conServicio.confirm( {
          message: this.navServicio.buscarMensaje( 'PRODUCTOCUESTIONARIO.MSG_GUARDARHABILITADO' ),
          header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
          icon: 'fa fa-question-circle',
          key: 'cuestionarios',
          accept: () => {
            habilitado.indicadorHabilitado = false;
            this.guardar( proCuestionario, habilitado );
          },
          reject: () => {
            this.guardando = false;
          }
        } );
      } else {
        this.guardar( proCuestionario );
      }
    }
  }

  editar( proCuestionario: ProductoCuestionario ) {
    this.proCuestionarioSeleccionado = proCuestionario;
    this.submitted = false;
    this.cargarFormulario();
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'cuestionarios',
        accept: () => {
          this.formulario.reset();
          this.f.idProducto.setValue( this.producto.idProducto );
          this.f.indicadorHabilitado.setValue( true );
          this.submitted = false;
          this.proCuestionarioSeleccionado = null;
        },
        reject: () => {
        }
      } );
    } else {
      this.formulario.reset();
      this.f.idProducto.setValue( this.producto.idProducto );
      this.f.indicadorHabilitado.setValue( true );
      this.submitted = false;
      this.proCuestionarioSeleccionado = null;
    }
  }


}
